"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.array(zod_1.z.object({
    cropId: zod_1.z.number(),
    dateRangeEnd: zod_1.z.string(),
    dateRangeStart: zod_1.z.string(),
    kc: zod_1.z.number(),
    organizationId: zod_1.z.number(),
    modelName: zod_1.z.string(),
    modelId: zod_1.z.string().nullable(),
}));
//# sourceMappingURL=kcModelUpsert.js.map